import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { MapPin, Navigation, Truck, Phone, Clock, Package, CheckCircle, AlertCircle } from 'lucide-react';
export function LogisticsTracking() {
  const activeTracking = [{
    id: 'PO-2023-001',
    trackingNumber: 'JNE88291002',
    driver: 'Ahmad Yani',
    vehicle: 'B 1234 XYZ',
    phone: '+62 812-9999-8888',
    currentLocation: 'Jl. Raya Bogor KM 35',
    destination: 'Koperasi Maju Jaya, Bogor',
    eta: '14:00 WIB',
    distance: '12 km',
    speed: '45 km/h',
    lastUpdate: '2 menit lalu',
    coordinates: {
      lat: -6.5971,
      lng: 106.806
    },
    route: [{
      time: '08:00',
      location: 'Gudang Transit Bogor',
      status: 'completed'
    }, {
      time: '10:30',
      location: 'Rest Area KM 30',
      status: 'completed'
    }, {
      time: '12:45',
      location: 'Jl. Raya Bogor KM 35',
      status: 'current'
    }, {
      time: '14:00',
      location: 'Koperasi Maju Jaya',
      status: 'pending'
    }]
  }, {
    id: 'PO-2023-004',
    trackingNumber: 'JNE88291005',
    driver: 'Budi Santoso',
    vehicle: 'B 5678 ABC',
    phone: '+62 813-8888-7777',
    currentLocation: 'Tol Cipularang KM 88',
    destination: 'Koperasi Sejahtera, Bandung',
    eta: '16:00 WIB',
    distance: '45 km',
    speed: '60 km/h',
    lastUpdate: '5 menit lalu',
    coordinates: {
      lat: -6.7024,
      lng: 107.5186
    },
    route: [{
      time: '09:00',
      location: 'Gudang Transit Bogor',
      status: 'completed'
    }, {
      time: '11:00',
      location: 'Tol Cipularang KM 50',
      status: 'completed'
    }, {
      time: '13:30',
      location: 'Tol Cipularang KM 88',
      status: 'current'
    }, {
      time: '16:00',
      location: 'Koperasi Sejahtera',
      status: 'pending'
    }]
  }];
  return <div className="space-y-6" data-id="element-2688">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2689">
        <div data-id="element-2690">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2691">Live Tracking</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2692">
            Monitor posisi kendaraan secara real-time
          </p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-lg" data-id="element-2693">
          <Navigation className="w-4 h-4 text-green-600 animate-pulse" data-id="element-2694" />
          <span className="text-sm font-bold text-green-700" data-id="element-2695">
            Live Tracking Active
          </span>
        </div>
      </div>

      {/* Map Placeholder */}
      <Card className="p-6 bg-slate-100 border-slate-300" data-id="element-2696">
        <div className="aspect-video bg-slate-200 rounded-lg flex items-center justify-center" data-id="element-2697">
          <div className="text-center" data-id="element-2698">
            <MapPin className="w-16 h-16 text-slate-400 mx-auto mb-4" data-id="element-2699" />
            <p className="text-lg font-bold text-slate-600" data-id="element-2700">Interactive Map</p>
            <p className="text-sm text-slate-500 mt-2" data-id="element-2701">
              Real-time vehicle tracking visualization
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-2702">
              (Integration with Google Maps / Mapbox)
            </p>
          </div>
        </div>
      </Card>

      {/* Active Vehicles */}
      <div className="grid grid-cols-2 gap-6" data-id="element-2703">
        {activeTracking.map(track => <Card key={track.id} className="p-6" data-id="element-2704">
            <div className="flex items-start justify-between mb-4" data-id="element-2705">
              <div data-id="element-2706">
                <div className="flex items-center gap-2 mb-2" data-id="element-2707">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-2708">
                    {track.id}
                  </h3>
                  <Badge variant="success" className="flex items-center gap-1" data-id="element-2709">
                    <Navigation className="w-3 h-3" data-id="element-2710" />
                    Live
                  </Badge>
                </div>
                <p className="text-sm text-slate-600 font-mono" data-id="element-2711">
                  {track.trackingNumber}
                </p>
              </div>
              <Button variant="outline" size="sm" icon={<Phone className="w-4 h-4" data-id="element-2713" />} data-id="element-2712">
                Call
              </Button>
            </div>

            {/* Driver Info */}
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200 mb-4" data-id="element-2714">
              <div className="flex items-center gap-3" data-id="element-2715">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold" data-id="element-2716">
                  {track.driver.split(' ').map(n => n[0]).join('')}
                </div>
                <div className="flex-1" data-id="element-2717">
                  <p className="font-bold text-slate-900" data-id="element-2718">{track.driver}</p>
                  <p className="text-sm text-slate-600" data-id="element-2719">{track.vehicle}</p>
                </div>
                <Truck className="w-6 h-6 text-blue-600" data-id="element-2720" />
              </div>
            </div>

            {/* Current Status */}
            <div className="space-y-3 mb-4" data-id="element-2721">
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-2722">
                <div className="flex items-center gap-2" data-id="element-2723">
                  <MapPin className="w-4 h-4 text-blue-600" data-id="element-2724" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-2725">
                    Current Location
                  </span>
                </div>
                <span className="text-sm font-bold text-slate-900" data-id="element-2726">
                  {track.currentLocation}
                </span>
              </div>

              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-2727">
                <div className="flex items-center gap-2" data-id="element-2728">
                  <Navigation className="w-4 h-4 text-green-600" data-id="element-2729" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-2730">
                    Destination
                  </span>
                </div>
                <span className="text-sm font-bold text-slate-900" data-id="element-2731">
                  {track.destination}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-2" data-id="element-2732">
                <div className="p-2 bg-slate-50 rounded-lg text-center" data-id="element-2733">
                  <p className="text-xs text-slate-600 mb-1" data-id="element-2734">ETA</p>
                  <p className="text-sm font-bold text-slate-900" data-id="element-2735">
                    {track.eta}
                  </p>
                </div>
                <div className="p-2 bg-slate-50 rounded-lg text-center" data-id="element-2736">
                  <p className="text-xs text-slate-600 mb-1" data-id="element-2737">Distance</p>
                  <p className="text-sm font-bold text-slate-900" data-id="element-2738">
                    {track.distance}
                  </p>
                </div>
                <div className="p-2 bg-slate-50 rounded-lg text-center" data-id="element-2739">
                  <p className="text-xs text-slate-600 mb-1" data-id="element-2740">Speed</p>
                  <p className="text-sm font-bold text-slate-900" data-id="element-2741">
                    {track.speed}
                  </p>
                </div>
              </div>
            </div>

            {/* Route Timeline */}
            <div className="pt-4 border-t border-slate-200" data-id="element-2742">
              <p className="text-sm font-bold text-slate-700 mb-3" data-id="element-2743">
                Route Progress
              </p>
              <div className="space-y-2" data-id="element-2744">
                {track.route.map((point, i) => <div key={i} className="flex items-center gap-3" data-id="element-2745">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${point.status === 'completed' ? 'bg-green-100 text-green-600' : point.status === 'current' ? 'bg-blue-100 text-blue-600' : 'bg-slate-100 text-slate-400'}`} data-id="element-2746">
                      {point.status === 'completed' ? <CheckCircle className="w-4 h-4" data-id="element-2747" /> : point.status === 'current' ? <Navigation className="w-4 h-4" data-id="element-2748" /> : <Clock className="w-4 h-4" data-id="element-2749" />}
                    </div>
                    <div className="flex-1" data-id="element-2750">
                      <p className={`text-sm font-medium ${point.status === 'current' ? 'text-blue-900' : 'text-slate-700'}`} data-id="element-2751">
                        {point.location}
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-2752">{point.time}</p>
                    </div>
                    {point.status === 'current' && <Badge variant="warning" className="text-xs" data-id="element-2753">
                        Current
                      </Badge>}
                  </div>)}
              </div>
            </div>

            {/* Last Update */}
            <div className="mt-4 pt-4 border-t border-slate-200" data-id="element-2754">
              <div className="flex items-center justify-between text-xs text-slate-500" data-id="element-2755">
                <span data-id="element-2756">Last update: {track.lastUpdate}</span>
                <Button variant="primary" size="sm" icon={<Navigation className="w-4 h-4" data-id="element-2758" />} data-id="element-2757">
                  View on Map
                </Button>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}